import { Component, Input } from '@angular/core';
import { Szme037aResponseCdtmnySyosaiRefInfDto } from 'sg-api';
import { DateDurationPipe } from '../../../../../sg-kd-shared/pipes/date-duration.pipe';

@Component({
  selector: 'app-urikakekin-teigaku-detail',
  templateUrl: './urikakekin-teigaku-detail.component.html',
  styleUrls: ['./urikakekin-teigaku-detail.component.scss'],
  providers: [DateDurationPipe]
})
export class UrikakekinTeigakuDetailComponent {
  @Input() urikakekinInfo: Szme037aResponseCdtmnySyosaiRefInfDto;
  @Input() prdClsfyDiv: string; 

  /** 画面表示項目 */
  displayedColumns: string[] = [
    'detailHyojiAname',
    'chargeCodeMny'
  ];

  constructor() { }

}
